import { PositionGeocode } from '../../position-geocode.entity';
import { PhotonFeature } from './photon-api.dto';

export function mapPhotonFeatureToPosition(
  feature: PhotonFeature,
): PositionGeocode {
  return {
    coordinates: feature.geometry.coordinates,
    properties: {
      name: formatName(feature),
      address: formatAddress(feature),
      city: formatCity(feature), // 'Paris'
      countryCode: feature.properties.countrycode || '', // 'FR'
    },
  };
}

const formatName = (feature: PhotonFeature): string => {
  const props = feature.properties;
  const parts = [props.name, props.city].filter(Boolean);
  return parts.join(' ');
};

const formatAddress = (feature: PhotonFeature): string => {
  const props = feature.properties;
  const parts = [
    props.name,
    props.street,
    props.city || props.county,
    props.state,
    props.country,
  ].filter(Boolean);
  return parts.join(', ');
};

const formatCity = (feature: PhotonFeature): string => {
  const props = feature.properties;

  // type "city"
  if (['city'].includes(props.osm_value) && props.name) {
    return props.name;
  }

  // "type": "house" for instance
  if (props.city) {
    return props.city;
  }

  // other cases
  // "type": "country" for instance (no city)
  return '';
};
